import React from 'react';
import { Box, useTheme } from '@mui/material';
import { ZALOHA_BARVA } from '../theme/zalohaBarva';

interface ZalohaPilulkaProps {
    pocet: number;
    /** Min. 1.05rem (cteni z 3-5 m); uzke pole technika-ucast smi dat 0.75rem. */
    fontSize?: string;
}

/**
 * Udaj „záloha N“ uvnitr zeleneho pole JEDU pod cislem (UX F1). Svetly rezim: bila pilulka
 * s indigo textem; nocni: svetle indigo #C5CAE9 s textem #1A237E. Pro 0 nic.
 */
export const ZalohaPilulka: React.FC<ZalohaPilulkaProps> = ({ pocet, fontSize = '1.05rem' }) => {
    const theme = useTheme();
    if (pocet <= 0) return null;
    const tmavy = theme.palette.mode === 'dark';
    return (
        <Box
            data-testid="semafor-zaloha"
            sx={{
                mt: 0.5, px: 0.75, py: 0.2, borderRadius: 1,
                bgcolor: tmavy ? '#C5CAE9' : '#FFFFFF',
                color: tmavy ? '#1A237E' : ZALOHA_BARVA,
                fontSize, fontWeight: 800, lineHeight: 1.2, whiteSpace: 'nowrap',
            }}
        >
            záloha {pocet}
        </Box>
    );
};
